<template>
  <div
    class="form-detail"
    v-if="
      ['COMPANY', 'HOUSEHOLD', 'INDIVIDUAL'].includes(contract.typeCustomer) &&
      item.enableSendMonthlyReport
    "
  >
    <div class="form-detail-line d-flex justify-content-between align-items-center">
      <h1>Thông tin nhận hoá đơn</h1>
      <div class="d-flex w-50 justify-content-end">
        <template v-if="!contract.confirmInvoice || contract.confirmInvoice === 'UNCONFIRMED'">
          <b-button variant="primary" size="sm" class="px-2 ml-3" @click="showModalUpdateInfo(item)"
            >Sửa</b-button
          >
          <b-button
            variant="primary"
            size="sm"
            class="px-2 ml-3"
            @click="contractConfirmInvoice('CONFIRMED')"
            >Xác thực</b-button
          >
        </template>
        <b-button
          v-else
          variant="primary"
          size="sm"
          class="px-2 ml-3"
          @click="contractConfirmInvoice('UNCONFIRMED')"
          >Bỏ xác thực</b-button
        >
      </div>
    </div>
    <Content title="Tên công ty" :content="item.invoiceMcName"></Content>
    <Content title="Địa chỉ" :content="item.invoiceMcAddress"></Content>
    <Content
      title="Mã số thuế / Mã quan hệ ngân sách"
      :content="item?.invoiceMcBusinessNumber"
    ></Content>
    <Content title="Họ và tên" :content="item.invoiceMcContactName"></Content>
    <Content title="Chức vụ" :content="item.invoiceMcContactPosition"></Content>
    <Content title="Email" :content="item.invoiceMcEmail"></Content>
    <Content title="Số điện thoại" :content="item.invoiceMcMobile"></Content>
    <Content title="Thông tin khác" :content="item.invoiceMcOtherContact"></Content>
    <Content
      title="Xác thực TTNHĐ"
      :content="contract.confirmInvoice === 'CONFIRMED' ? 'Đã xác thực' : 'Chưa xác thực'"
    >
    </Content>

    <!-- modal -->
    <b-modal
      :visible="showUpdateInfo"
      title="Sửa thông tin xuất hoá đơn"
      @hide="closeModalUpdateInfo"
      ignore-enforce-focus-selector="input"
    >
      <ValidationObserver ref="formData">
        <form @submit.prevent="">
          <ValidationProvider rules="required" vid="invoiceMcName" name="Tên công ty">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label"
                >Tên công ty<span style="color: red"> *</span></label
              >
              <div class="col-sm-9">
                <input class="form-control" v-model.trim="formData.invoiceMcName" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" vid="invoiceMcAddress" name="Địa chỉ">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label"
                >Địa chỉ<span style="color: red"> *</span></label
              >
              <div class="col-sm-9">
                <input class="form-control" v-model.trim="formData.invoiceMcAddress" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" vid="invoiceMcBusinessNumber" name="Mã số thuế">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label"
                >Mã số thuế<span style="color: red"> *</span></label
              >
              <div class="col-sm-9">
                <input class="form-control" v-model.trim="formData.invoiceMcBusinessNumber" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" vid="invoiceMcContactName" name="Họ và tên">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label"
                >Họ và tên<span style="color: red"> *</span></label
              >
              <div class="col-sm-9">
                <input class="form-control" v-model.trim="formData.invoiceMcContactName" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" vid="invoiceMcContactPosition" name="Chức vụ">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label"
                >Chức vụ<span style="color: red"> *</span></label
              >
              <div class="col-sm-9">
                <input class="form-control" v-model.trim="formData.invoiceMcContactPosition" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required|mail" vid="invoiceMcEmail" name="Email">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label"
                >Email<span style="color: red"> *</span></label
              >
              <div class="col-sm-9">
                <input class="form-control" v-model.trim="formData.invoiceMcEmail" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" vid="invoiceMcMobile" name="Số điện thoại">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label"
                >Số điện thoại<span style="color: red"> *</span></label
              >
              <div class="col-sm-9">
                <input class="form-control" v-model.trim="formData.invoiceMcMobile" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
        </form>
      </ValidationObserver>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button variant="" @click="closeModalUpdateInfo" class="mr-2"> Huỷ bỏ </b-button>
          <b-button variant="primary" @click="submitUpdateInfo"> Lưu lại </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal -->

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import Content from './Content.vue'
  import { ContractService } from '@/services/contract.service'
  import _ from 'lodash'
  import { mapGetters } from 'vuex'

  export default {
    props: {
      item: {
        type: Object,
        default: () => {},
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        showLoading: false,
        showUpdateInfo: false,
        formData: {},
      }
    },
    components: { Content },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      canUpdateInvoice() {
        return this.dataPermission.includes('CNPS_SCON_UPDATE_INVOICE')
      },
      async contractConfirmInvoice(action) {
        const check = this.canUpdateInvoice()
        if (!check) {
          this.showFailMx('Không có quyền thao tác')
          return
        }
        // console.log({ item: this.item, contract: this.contract })
        const textAction = action === 'CONFIRMED' ? 'xác thực' : 'bỏ xác thực'
        try {
          const flag = await this.approveMx(
            `Bạn có chắc chắn muốn ${textAction} thông tin nhận hoá đơn`
          )
          if (!flag) return false

          this.showLoading = true
          const params = {
            action, // CONFIRMED/UNCONFIRMED
            contractId: this.contract.id,
          }
          // console.log(params)
          // return
          const res = await ContractService.contractConfirmInvoice(params)
          if (res.code === 1000) {
            this.showLoading = false
            this.showSuccessMx(`${action === 'CONFIRMED' ? 'Xác thực' : 'Bỏ xác thực'} thành công!`)
            this.$emit('fetch-data')
          } else {
            throw new Error(res.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      // showModalUpdateInfo(item) {
      //   const check = this.canUpdateInvoice()
      //   if (!check) {
      //     this.showFailMx('Không có quyền thao tác')
      //     return
      //   }
      //   this.formData = _.cloneDeep(item)
      //   this.showUpdateInfo = true
      // },
      showModalUpdateInfo(item) {
        const check = this.canUpdateInvoice()
        if (!check) {
          this.showFailMx('Không có quyền thao tác')
          return
        }
        this.formData = _.cloneDeep(item)

        if (this.contract?.typeCustomer !== 'HOUSEHOLD') {
          // Gán giá trị mặc định từ thông tin người đại diện nếu chưa có
          if (!this.formData.invoiceMcName && this.item.customerName) {
            this.formData.invoiceMcName = this.item.customerName
          }
          if (!this.formData.invoiceMcAddress && this.item.authoriserAddress1) {
            this.formData.invoiceMcAddress = this.item.authoriserAddress1
          }
          if (!this.formData.invoiceMcBusinessNumber && this.item.passport) {
            this.formData.invoiceMcBusinessNumber = this.item.passport
          }
          if (!this.formData.invoiceMcContactName && this.item.customerName) {
            this.formData.invoiceMcContactName = this.item.customerName
          }
          if (!this.formData.invoiceMcContactPosition) {
            this.formData.invoiceMcContactPosition = this.item.position || 'Chủ hộ'
          }
          if (!this.formData.invoiceMcEmail && this.item.authoriserEmail) {
            this.formData.invoiceMcEmail = this.item.authoriserEmail
          }
          if (!this.formData.invoiceMcMobile && this.item.authoriserContactNumber) {
            this.formData.invoiceMcMobile = this.item.authoriserContactNumber
          }
        } else {
          // HOUSEHOLD - Gán giá trị mặc định từ thông tin MC
          if (!this.formData.invoiceMcName && this.item.merchantName) {
            this.formData.invoiceMcName = this.item.merchantName
          }
          if (!this.formData.invoiceMcAddress) {
            const address = `${this.item.address}, ${this.item.district}, ${this.item.city}`
            this.formData.invoiceMcAddress = address
          }
          if (!this.formData.invoiceMcBusinessNumber && this.item.businessRegistrationNumber) {
            this.formData.invoiceMcBusinessNumber = this.item.businessRegistrationNumber
          }
          if (!this.formData.invoiceMcContactName && this.item.customerName) {
            this.formData.invoiceMcContactName = this.item.customerName
          }
          if (!this.formData.invoiceMcContactPosition) {
            this.formData.invoiceMcContactPosition = this.item.position || 'Chủ hộ'
          }
          if (!this.formData.invoiceMcEmail && this.item.authoriserEmail) {
            this.formData.invoiceMcEmail = this.item.authoriserEmail
          }
          if (!this.formData.invoiceMcMobile && this.item.authoriserContactNumber) {
            this.formData.invoiceMcMobile = this.item.authoriserContactNumber
          }
        }

        this.showUpdateInfo = true
      },
      closeModalUpdateInfo() {
        this.formData = {}
        this.showUpdateInfo = false
      },
      async submitUpdateInfo() {
        const check = this.canUpdateInvoice()
        if (!check) {
          this.showFailMx('Không có quyền thao tác')
          return
        }

        const isSuccess = await this.$refs.formData.validate()
        if (!isSuccess) return
        try {
          const params = {
            contractId: null,
            customerId: null,
            invoiceMcAddress: null,
            invoiceMcBusinessNumber: null,
            invoiceMcContactName: null,
            invoiceMcContactPosition: null,
            invoiceMcEmail: null,
            invoiceMcMobile: null,
            invoiceMcName: null,
          }
          for (const property in params) {
            params[property] = this.formData[property]
          }
          params.contractId = this.contract.id

          this.showLoading = true
          // console.log(params)
          // return
          const res = await ContractService.contractUpdateInfoInvoice(params)
          if (res.code === 1000) {
            this.showLoading = false
            this.closeModalUpdateInfo()
            this.showSuccessMx('Cập nhật thông tin nhận hoá đơn thành công!')
            this.$emit('fetch-data')
          } else {
            throw new Error(res.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped>
  .form-detail-line {
    padding-bottom: 5px;
    border-bottom: 1px solid #dcdcdc;
    margin-bottom: 10px !important;
    width: 100%;
  }

  .form-detail h1 {
    font-size: 16px;
    padding-bottom: 0;
    border-bottom: none;
    margin-bottom: 0 !important;
  }

  .btn-text {
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    cursor: pointer;
    color: #319db5;
  }
</style>
